import React from "react";
import { IMGWrapper } from "./styled";

const AdminLogo = ({customStyles, alt}: any) => {
  return ( 
    <IMGWrapper src="/images/logo.png" alt={alt} $customStyles={{maxHeight: "100%", maxWidth: "100%",...customStyles}} />
  );
};
  
export default AdminLogo;